import { useState, useMemo } from 'react';
import { MantineReactTable, useMantineReactTable } from 'mantine-react-table';
import MiniLineChart from '../mini-line-chart/mini-line-chart.component';

const TableSorting = ({ rowNames, surveyData }) => {

    const [isFullScreen, setIsFullScreen] = useState(false);

    const columns = useMemo(() => {
        return rowNames.map(item => {
            if (item['columnKey'].includes('changeHistory')) {
                // Remove -changeHistory from the column key
                const questionId = item['columnKey'].replace('-changeHistory', '');
                return {
                    accessorKey: item['columnKey'],
                    header: item['columnName'],
                    Cell: ({ renderedCellValue, row }) => (
                        <MiniLineChart
                            data = { renderedCellValue }
                            questionId = { questionId }
                            callId = { row.original['alias-id'] }
                            questionText = { row.original[`${questionId}-alias-question`] }
                        />
                    ),
                    enableSorting: false,
                    enableColumnFilter: false,
                };
            }
            return {
                accessorKey: item['columnKey'],
                header: item['columnName'],
            };
        });
    }, [rowNames]);

    const table = useMantineReactTable({
        columns,
        data: surveyData,
        mantineTableProps: { striped: true },
        mantinePaperProps: {
            sx: { border: 'none !important', boxShadow: 'none !important' },
        },
        mantineTopToolbarProps: {
            sx: {
                marginRight: isFullScreen ? '15px' : '0px',
                transition: 'none !important',
            },
        },
        onIsFullScreenChange: () => { setIsFullScreen(!isFullScreen) },
        state: { isFullScreen },
    });

    return <MantineReactTable table={table} />
};

export default TableSorting;